import { render } from "./AppNavigationContactsItem.vue?vue&type=template&id=682046ca&scoped=true"
import script from "./AppNavigationContactsItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationContactsItem.vue?vue&type=script&lang=js"

import "./AppNavigationContactsItem.vue?vue&type=style&index=0&id=682046ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682046ca"]])

export default __exports__